import { CollectionEntity } from "@busy-human/gearbox";
export var Invoices;
(function (Invoices) {
    function getInvoiceId(builderId, seasonId) {
        return `${builderId}:${seasonId}`;
    }
    Invoices.getInvoiceId = getInvoiceId;
    function Default() {
        return {
            builderId: "",
            contactId: "",
            dueDate: new Date().toISOString(),
            invoiceDate: new Date().toISOString(),
            invoiceType: "Sales Order Deposit",
            parentBuilderId: "",
            remainingBalance: 0,
            season: "",
            status: "Incomplete",
            totalCharges: 0,
            totalOwed: 0,
            totalPaid: 0,
            totalReceipts: 0
        };
    }
    Invoices.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    Invoices.CollectionClass = CollectionClass;
    Invoices.Collection = new CollectionClass({ path: "Invoices" });
    async function getFirestoreId(zohoId) {
        const subset = Invoices.Collection.subset(q => q.where('zohoId', '==', zohoId));
        await subset.fetch();
        return subset.size > 0 ? subset.dataItems()[0].$id : undefined;
    }
    Invoices.getFirestoreId = getFirestoreId;
    async function getZohoId(firebaseId) {
        const item = await Invoices.Collection.fetchData(firebaseId);
        if (item) {
            return item.zohoId;
        }
        else {
            return undefined;
        }
    }
    Invoices.getZohoId = getZohoId;
})(Invoices || (Invoices = {}));
//# sourceMappingURL=index.js.map